/**
 * Back navigation for detail screens.
 *
 * iOS has no hardware back key and the app's WKWebView has no swipe-back,
 * so a screen reached by tapping into it (e.g. a product) needs its own
 * back button. Pure helpers — unit-tested in backNavigation.test.js.
 */

/** Screens that get a back button in place of the menu button. */
const DETAIL_ROUTES = [/^\/product\/[^/]+\/?$/];

export function isDetailRoute(pathname) {
  return DETAIL_ROUTES.some((re) => re.test(pathname || ""));
}

/**
 * True when there is an earlier entry of this app in the history stack.
 * React Router's BrowserRouter stores the entry index as `history.state.idx`;
 * 0 means the screen was opened directly (shared link, notification tap,
 * app launch), where "back" would leave the app or do nothing.
 */
export function canGoBackInApp(historyState) {
  return typeof historyState?.idx === "number" && historyState.idx > 0;
}

/**
 * History state for a navigation made outside React Router (a notification
 * tap): the same {usr, key, idx} shape the router writes. A bare `{}` has no
 * idx, and every later router entry would then get idx NaN — the back button
 * would stop going back for the rest of the session.
 */
export function routerHistoryState(current, key = Math.random().toString(36).slice(2, 10)) {
  const idx = typeof current?.idx === "number" ? current.idx + 1 : 0;
  return { usr: null, key, idx };
}

/** Where "back" goes when there is nothing to go back to. */
export function backFallback(pathname) {
  return isDetailRoute(pathname) ? "/shop" : "/";
}
